import React, { useState, useEffect } from 'react';
import { Camera, Save, Upload } from 'lucide-react';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import '../../../css/custom-scrollbar.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from '../../../component/spinner/spinner';
import { Base_Url, userdata, updateprofile, Url_For_View_Document } from '../../../config/config';
import { useNavigate } from 'react-router-dom';

const B2bUserProfileEdit = () => {
    const [hasExistingAccount, setHasExistingAccount] = useState(false);
    const [originalAccountNo, setOriginalAccountNo] = useState('');
    const [hasExistingAccountHolder, setHasExistingAccountHolder] = useState(false);
    const [originalAccountHolder, setOriginalAccountHolder] = useState('');
    const [hasExistingBankName, setHasExistingBankName] = useState(false);
    const [originalBankName, setOriginalBankName] = useState('');
    const [hasExistingIfscCode, setHasExistingIfscCode] = useState(false);
    const [originalIfscCode, setOriginalIfscCode] = useState('');
    const { isDarkMode, isToggleSidebar } = useMyContext();
    const [cancelCheckFile, setCancelCheckFile] = useState(null);
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const [isLoading, isSetLoading] = useState(false);
    const navigate = useNavigate();

    const [profileImagePreview, setProfileImagePreview] = useState(null);
    const [selectedProfileImage, setSelectedProfileImage] = useState(null);

    const [userData, setUserData] = useState({
        id: cusid,
        company_name: "test",
        name: '',
        bio: '',
        email: '',
        phone: '',
        website: '',
        address: '',
        account_holder: '',
        bank_name: '',
        account_no: '',
        ifsc_code: ''
    });

    const handleCancelCheckUpload = (event) => {
        const file = event.target.files[0];
        setCancelCheckFile(file);
    };

    const handleProfileImage = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        setSelectedProfileImage(file);

        const reader = new FileReader();
        reader.onloadend = () => {
            setProfileImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleCancelCheckRemove = () => {
        setCancelCheckFile(null);
    };


    const generateInitialsAvatar = (name) => {
        if (!name) return null;
        const initials = name.charAt(0).toUpperCase() + name.charAt(1).toUpperCase();
        return (
            <div
                className="rounded-full mt-16 flex items-center justify-center bg-customPurple text-white text-6xl font-bold"
                style={{ width: '193px', height: '193px' }}
            >
                {initials}
            </div>

        );
    };

    useEffect(() => {
        fetchUserData();
    }, [cusid, token]);

    const fetchUserData = async () => {
        const url = Base_Url + userdata;
        if (cusid) {
            try {
                const response = await fetch(url + "/" + cusid, {
                    method: 'GET',
                    headers: {
                        'token': token,
                        'cus_id': cusid,
                        'Content-Type': 'application/json',
                    },
                });

                const result = await response.json();
                if (result.status === "SUCCESS") {
                    const { data } = result;
                    // Check for existing bank details
                    if (data.account_no) {
                        setHasExistingAccount(true);
                        setOriginalAccountNo(data.account_no);
                    }
                    if (data.account_holder_name) {
                        setHasExistingAccountHolder(true);
                        setOriginalAccountHolder(data.account_holder_name);
                    }
                    if (data.bank_name) {
                        setHasExistingBankName(true);
                        setOriginalBankName(data.bank_name);
                    }
                    if (data.ifsc_code) {
                        setHasExistingIfscCode(true);
                        setOriginalIfscCode(data.ifsc_code);
                    }

                    setUserData({
                        id: cusid,
                        name: data.name || '',
                        company_name: data.company_name || '',
                        bio: data.bio,
                        email: data.email || '',
                        phone: data.phone || '',
                        website: data.website || '',
                        address: data.address || '',
                        account_holder: data.account_holder_name,
                        bank_name: data.bank_name,
                        account_no: data.account_no || '',
                        ifsc_code: data.ifsc_code
                    });
                    if (data.profile_image) {
                        const profileWithUrl = Url_For_View_Document + data.profile_image
                        setProfileImagePreview(profileWithUrl);
                    }
                    else {
                        setProfileImagePreview(data.profile_image);
                    }
                } else {
                    toast.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                toast.error('Something went wrong. Please try again.');
            }
        }
    };


    const handleSubmit = async () => {
        const formData = new FormData();
        if (hasExistingAccount) {
            formData.append('account_no', originalAccountNo);
        } else {
            formData.append('account_no', userData.account_no);
        }

        if (hasExistingAccountHolder) {
            formData.append('account_holder', originalAccountHolder);
        } else {
            formData.append('account_holder', userData.account_holder);
        }

        if (hasExistingBankName) {
            formData.append('bank_name', originalBankName);
        } else {
            formData.append('bank_name', userData.bank_name);
        }

        if (hasExistingIfscCode) {
            formData.append('ifsc_code', originalIfscCode);
        } else {
            formData.append('ifsc_code', userData.ifsc_code);
        }

        // Append other fields
        for (const key in userData) {
            if (!['account_no', 'account_holder', 'bank_name', 'ifsc_code'].includes(key)) {
                formData.append(key, userData[key]);
            }
        }

        // Append profile image if selected
        if (selectedProfileImage) {
            formData.append('profile_image', selectedProfileImage);
        }

        if (cancelCheckFile) {
            formData.append('cancel_check', cancelCheckFile);
        }

        try {
            isSetLoading(true);
            const response = await axios.post(`${Base_Url}${updateprofile}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'token': token,
                    'cus_id': cusid,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                isSetLoading(false);
                setTimeout(() => {
                    navigate("/b2b/dashboard");
                }, 1000)
            } else {
                toast.error(response.data.message.ifsc_code);
                toast.error(response.data.message.profile_image);
                toast.error(response.data.message.ifsc_code);
                toast.error(response.data.message.account_no);
                toast.error(response.data.message.address);
                toast.error(response.data.message.website);
                toast.error(response.data.message.cancel_check);
                isSetLoading(false);
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Something went wrong. Please try again.');
            isSetLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === 'phone') {
            const phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(value)) {
                return;
            }
        }
        if (
            (id === 'account_no' && hasExistingAccount) ||
            (id === 'account_holder' && hasExistingAccountHolder) ||
            (id === 'bank_name' && hasExistingBankName) ||
            (id === 'ifsc_code' && hasExistingIfscCode)
        ) {
            return;
        }
        setUserData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };
    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gradient-to-br from-gray-50 to-gray-100'}`}>
            <div className="z-10">
                <NavBar />
            </div>

            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor md:bg-transparent mt-4 md:w-64 md:z-20`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }>
                        <Sidebar />
                    </div>
                )}
                <div className='rounded-custom  bg-gray-100 mb-2  dark:shadow-custom-dark overflow-y-auto w-full custom-scrollbar '>
                    <div className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 mt-3">
                        <div className="max-w-5xl mx-auto bg-white dark:bg-darkmodeColor rounded-custom custom-scrollbar shadow-2xl dark:shadow-custom-dark overflow-hidden border border-gray-200 dark:border-gray-700">
                            {/* Header Section */}
                            <div className="px-6 py-6 bg-gradient-to-r from-gray-50 to-gray-100 dark:bg-gradient-to-r dark:from-darkmodeColor dark:to-[rgba(1,14,78,0.98)] border-b border-gray-200 dark:border-gray-700">
                                <h1 className="text-3xl font-bold text-gray-800 dark:text-white flex items-center">
                                    <span className="w-2 h-8 bg-customPurple rounded-full mr-3"></span>
                                    Edit Profile
                                </h1>
                                <p className="text-gray-600 dark:text-gray-300 mt-2">Update your personal and professional information</p>
                            </div>

                            <div className="p-8">
                                {/* Public Information Section */}
                                <div className="mb-10">
                                    <div className="flex items-center mb-6">
                                        <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">Public Information</h2>
                                        <div className="ml-3 px-3 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 text-sm rounded-full">
                                            Visible to others
                                        </div>
                                    </div>

                                    <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-6 lg:space-y-0 lg:space-x-8 bg-gray-50 dark:bg-[rgba(1,14,78,0.8)] p-6 rounded-xl">
                                        {/* Profile Image Section */}
                                        <div className="relative">
                                            {profileImagePreview ? (
                                                <img
                                                    src={profileImagePreview}
                                                    alt="Profile"
                                                    className="w-48 h-48 object-cover border-4 border-white dark:border-gray-600 shadow-xl rounded-full hover:shadow-2xl transition-shadow duration-300"
                                                />
                                            ) : (
                                                <div className="w-48 h-48 border-4 border-white dark:border-gray-600 shadow-xl rounded-full">
                                                    {generateInitialsAvatar(userData.name)}
                                                </div>
                                            )}
                                            <button
                                                onClick={() => document.getElementById("profileImageInput").click()}
                                                className="absolute bottom-2 right-2 bg-customPurple hover:bg-purple-700 text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105"
                                            >
                                                <Camera className="w-6 h-6" />
                                            </button>
                                            <input
                                                type="file"
                                                id="profileImageInput"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                style={{ display: 'none' }}
                                                onChange={handleProfileImage}
                                            />
                                        </div>

                                        {/* Profile Form Fields */}
                                        <div className="flex-grow space-y-6 w-full lg:w-auto">
                                            <div>
                                                <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                    Full Name *
                                                </label>
                                                <input
                                                    id="name"
                                                    type="text"
                                                    placeholder="Enter your full name"
                                                    value={userData.name}
                                                    onChange={handleInputChange}
                                                    className="w-full p-4 border-2 border-gray-200 dark:border-gray-600 rounded-xl shadow-sm dark:bg-darkmodeColor dark:text-white focus:border-customPurple focus:ring-2 focus:ring-purple-200 dark:focus:ring-purple-800 transition-all duration-200 hover:border-gray-300 dark:hover:border-gray-500"
                                                />
                                            </div>
                                            <div>
                                                <label htmlFor="username" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                    Username
                                                </label>
                                                <input
                                                    id="username"
                                                    type="text"
                                                    placeholder="Choose a username"
                                                    value={userData.company_name}
                                                    onChange={handleInputChange}
                                                    className="w-full p-4 border-2 border-gray-200 dark:border-gray-600 rounded-xl shadow-sm dark:bg-darkmodeColor dark:text-white focus:border-customPurple focus:ring-2 focus:ring-purple-200 dark:focus:ring-purple-800 transition-all duration-200 hover:border-gray-300 dark:hover:border-gray-500"
                                                />
                                            </div>
                                            <div>
                                                <label htmlFor="bio" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                    Biography
                                                </label>
                                                <textarea
                                                    id="bio"
                                                    placeholder="Tell us about yourself..."
                                                    value={userData.bio}
                                                    onChange={handleInputChange}
                                                    className="w-full p-4 border-2 border-gray-200 dark:border-gray-600 rounded-xl shadow-sm dark:bg-darkmodeColor dark:text-white focus:border-customPurple focus:ring-2 focus:ring-purple-200 dark:focus:ring-purple-800 transition-all duration-200 hover:border-gray-300 dark:hover:border-gray-500 resize-none"
                                                    rows="4"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Private Information Section */}
                                <div className="mb-10">
                                    <div className="flex items-center mb-6">
                                        <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">Private Information</h2>
                                        <div className="ml-3 px-3 py-1 bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300 text-sm rounded-full">
                                            Personal details
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                        {/* Email - Non-editable */}
                                        <div className="relative">
                                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                Email Address
                                                <span className="ml-2 text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 px-2 py-1 rounded">Read-only</span>
                                            </label>
                                            <input
                                                id="email"
                                                type="email"
                                                placeholder="Email address"
                                                disabled
                                                value={userData.email}
                                                onChange={handleInputChange}
                                                className="w-full p-4 border-2 border-gray-100 dark:border-gray-700 rounded-xl bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400 cursor-not-allowed"
                                            />
                                            <div className="absolute top-0 right-0 mt-2 mr-2">
                                                <div className="w-3 h-3 bg-gray-400 rounded-full"></div>
                                            </div>
                                        </div>

                                         <div className="relative">
                                            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                  Phone Number
                                                <span className="ml-2 text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 px-2 py-1 rounded">Read-only</span>
                                            </label>
                                            <input
                                                id="phone"
                                                type="tel"
                                                placeholder="Enter phone number"
                                                disabled
                                                value={userData.phone}
                                                onChange={handleInputChange}
                                                className="w-full p-4 border-2 border-gray-100 dark:border-gray-700 rounded-xl bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400 cursor-not-allowed"
                                            />
                                            <div className="absolute top-0 right-0 mt-2 mr-2">
                                                <div className="w-3 h-3 bg-gray-400 rounded-full"></div>
                                            </div>
                                        </div>


                                        {/* Website - Editable */}
                                        <div>
                                            <label htmlFor="website" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                Website
                                            </label>
                                            <input
                                                id="website"
                                                type="url"
                                                placeholder="https://your-website.com"
                                                value={userData.website}
                                                onChange={handleInputChange}
                                                className="w-full p-4 border-2 border-gray-200 dark:border-gray-600 rounded-xl shadow-sm dark:bg-darkmodeColor dark:text-white focus:border-customPurple focus:ring-2 focus:ring-purple-200 dark:focus:ring-purple-800 transition-all duration-200 hover:border-gray-300 dark:hover:border-gray-500"
                                            />
                                        </div>

                                        {/* User ID - Non-editable */}
                                        <div className="relative">
                                            <label htmlFor="UserId" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                User ID
                                                <span className="ml-2 text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 px-2 py-1 rounded">System generated</span>
                                            </label>
                                            <input
                                                id="UserId"
                                                type="text"
                                                placeholder="User ID"
                                                disabled
                                                value={userData.id}
                                                onChange={handleInputChange}
                                                className="w-full p-4 border-2 border-gray-100 dark:border-gray-700 rounded-xl bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400 cursor-not-allowed"
                                            />
                                            <div className="absolute top-0 right-0 mt-2 mr-2">
                                                <div className="w-3 h-3 bg-gray-400 rounded-full"></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Address - Full width */}
                                    <div className="mt-6">
                                        <label htmlFor="address" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                            Address
                                        </label>
                                        <textarea
                                            id="address"
                                            placeholder="Enter your complete address"
                                            value={userData.address}
                                            onChange={handleInputChange}
                                            className="w-full p-4 border-2 border-gray-200 dark:border-gray-600 rounded-xl shadow-sm dark:bg-darkmodeColor dark:text-white focus:border-customPurple focus:ring-2 focus:ring-purple-200 dark:focus:ring-purple-800 transition-all duration-200 hover:border-gray-300 dark:hover:border-gray-500 resize-none"
                                            rows="3"
                                        ></textarea>
                                    </div>
                                </div>

                                {/* Bank Details Section */}
                                <div className="mb-8">
                                    <div className="flex items-center mb-6">
                                        <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">Bank Details</h2>
                                        <div className="ml-3 px-3 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-sm rounded-full">
                                            Financial information
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                        {/* Account Holder Name */}
                                        <div className={`relative ${hasExistingAccountHolder ? 'opacity-75' : ''}`}>
                                            <label htmlFor="account_holder" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                Account Holder Name
                                                {hasExistingAccountHolder && (
                                                    <span className="ml-2 text-xs bg-yellow-200 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 px-2 py-1 rounded">Locked</span>
                                                )}
                                            </label>
                                            <input
                                                id="account_holder"
                                                type="text"
                                                placeholder="Enter Account Holder Name"
                                                value={hasExistingAccountHolder ? originalAccountHolder : userData.account_holder}
                                                onChange={handleInputChange}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, '');
                                                }}
                                                disabled={hasExistingAccountHolder}
                                                className={`w-full p-4 border-2 rounded-xl shadow-sm transition-all duration-200 ${hasExistingAccountHolder
                                                        ? 'border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400 cursor-not-allowed'
                                                        : 'border-gray-200 dark:border-gray-600 dark:bg-darkmodeColor dark:text-white focus:border-customPurple focus:ring-2 focus:ring-purple-200 dark:focus:ring-purple-800 hover:border-gray-300 dark:hover:border-gray-500'
                                                    }`}
                                            />
                                            {hasExistingAccountHolder && (
                                                <div className="absolute top-0 right-0 mt-2 mr-2">
                                                    <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                                                </div>
                                            )}
                                        </div>

                                        {/* Bank Name */}
                                        <div className={`relative ${hasExistingBankName ? 'opacity-75' : ''}`}>
                                            <label htmlFor="bank_name" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                Bank Name
                                                {hasExistingBankName && (
                                                    <span className="ml-2 text-xs bg-yellow-200 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 px-2 py-1 rounded">Locked</span>
                                                )}
                                            </label>
                                            <input
                                                id="bank_name"
                                                type="text"
                                                placeholder="Enter Bank Name"
                                                value={hasExistingBankName ? originalBankName : userData.bank_name}
                                                onChange={handleInputChange}
                                                disabled={hasExistingBankName}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^a-zA-Z ]/g, '');
                                                }}
                                                className={`w-full p-4 border-2 rounded-xl shadow-sm transition-all duration-200 ${hasExistingBankName
                                                        ? 'border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400 cursor-not-allowed'
                                                        : 'border-gray-200 dark:border-gray-600 dark:bg-darkmodeColor dark:text-white focus:border-customPurple focus:ring-2 focus:ring-purple-200 dark:focus:ring-purple-800 hover:border-gray-300 dark:hover:border-gray-500'
                                                    }`}
                                            />
                                            {hasExistingBankName && (
                                                <div className="absolute top-0 right-0 mt-2 mr-2">
                                                    <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                                                </div>
                                            )}
                                        </div>

                                        {/* Account Number */}
                                        <div className={`relative ${hasExistingAccount ? 'opacity-75' : ''}`}>
                                            <label htmlFor="account_no" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                Account Number
                                                {hasExistingAccount && (
                                                    <span className="ml-2 text-xs bg-yellow-200 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 px-2 py-1 rounded">Locked</span>
                                                )}
                                            </label>
                                            <input
                                                id="account_no"
                                                type="text"
                                                placeholder="Enter Account Number"
                                                value={hasExistingAccount ? originalAccountNo : userData.account_no}
                                                onChange={handleInputChange}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                }}
                                                disabled={hasExistingAccount}
                                                className={`w-full p-4 border-2 rounded-xl shadow-sm transition-all duration-200 ${hasExistingAccount
                                                        ? 'border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400 cursor-not-allowed'
                                                        : 'border-gray-200 dark:border-gray-600 dark:bg-darkmodeColor dark:text-white focus:border-customPurple focus:ring-2 focus:ring-purple-200 dark:focus:ring-purple-800 hover:border-gray-300 dark:hover:border-gray-500'
                                                    }`}
                                            />
                                            {hasExistingAccount && (
                                                <div className="absolute top-0 right-0 mt-2 mr-2">
                                                    <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                                                </div>
                                            )}
                                        </div>

                                        {/* IFSC Code */}
                                        <div className={`relative ${hasExistingIfscCode ? 'opacity-75' : ''}`}>
                                            <label htmlFor="ifsc_code" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                                IFSC Code
                                                {hasExistingIfscCode && (
                                                    <span className="ml-2 text-xs bg-yellow-200 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 px-2 py-1 rounded">Locked</span>
                                                )}
                                            </label>
                                            <input
                                                id="ifsc_code"
                                                type="text"
                                                placeholder="Enter IFSC Code"
                                                value={hasExistingIfscCode ? originalIfscCode : userData.ifsc_code}
                                                onChange={handleInputChange}
                                                disabled={hasExistingIfscCode}
                                                className={`w-full p-4 border-2 rounded-xl shadow-sm transition-all duration-200 ${hasExistingIfscCode
                                                        ? 'border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400 cursor-not-allowed'
                                                        : 'border-gray-200 dark:border-gray-600 dark:bg-darkmodeColor dark:text-white focus:border-customPurple focus:ring-2 focus:ring-purple-200 dark:focus:ring-purple-800 hover:border-gray-300 dark:hover:border-gray-500'
                                                    }`}
                                            />
                                            {hasExistingIfscCode && (
                                                <div className="absolute top-0 right-0 mt-2 mr-2">
                                                    <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Cancel Check Upload Section */}
                                    <div className="mt-8 p-6 bg-gray-50 dark:bg-[rgba(1,14,78,0.8)] rounded-xl border-2 border-dashed border-gray-300 dark:border-gray-600">
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-4">
                                            Upload Cancelled Check
                                            <span className="block text-xs text-gray-500 dark:text-gray-400 mt-1">Accepted formats: PDF, JPG, JPEG, PNG</span>
                                        </label>
                                        <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-4">
                                            <input
                                                type="file"
                                                id="cancel-check-upload"
                                                className="hidden"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                onChange={handleCancelCheckUpload}
                                            />
                                            <label
                                                htmlFor="cancel-check-upload"
                                                className="flex items-center space-x-3 bg-customPurple hover:bg-purple-700 text-white px-6 py-3 rounded-xl cursor-pointer transition-all duration-300 hover:shadow-lg transform hover:scale-105"
                                            >
                                                <Upload className="w-5 h-5" />
                                                <span className="font-medium">Choose File</span>
                                            </label>

                                            {cancelCheckFile && (
                                                <div className="flex items-center space-x-3 bg-white dark:bg-gray-800 p-3 rounded-xl shadow-sm border border-gray-200 dark:border-gray-600">
                                                    <div className="flex items-center space-x-2">
                                                        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                                        <span className="text-gray-700 dark:text-white font-medium">
                                                            {cancelCheckFile.name}
                                                        </span>
                                                    </div>
                                                    <button
                                                        onClick={handleCancelCheckRemove}
                                                        className="text-red-500 hover:text-red-700 transition-colors duration-200 font-medium"
                                                        type="button"
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Footer Section */}
                            <div className="px-8 py-6 bg-gradient-to-r from-gray-50 to-gray-100 dark:bg-gradient-to-r dark:from-darkmodeColor dark:to-[rgba(1,14,78,0.98)] border-t border-gray-200 dark:border-gray-700 flex justify-between items-center">
                                <div className="text-sm text-gray-600 dark:text-gray-400">
                                    <span className="flex items-center">
                                        <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                                        All changes are auto-saved
                                    </span>
                                </div>
                                <button
                                    className="flex items-center space-x-3 bg-gradient-to-r from-customPurple to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white px-8 py-3 rounded-xl font-medium transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                                    onClick={handleSubmit}
                                >
                                    <Save className="w-5 h-5" />
                                    {isLoading ? <Spinner /> : <span>Save Changes</span>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default B2bUserProfileEdit;   